var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('event-form',[_c('ButtonCreate',{staticClass:"mt_m"}),_c('ButtonCreateAutoEntry',{staticClass:"mt_m"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }